import { useParams } from 'react-router-dom';
import { ManagementSection } from './ManagementSection';
import { VenueEventsManagement } from '../../components/VenueEventsManagement';

export const EventsSection = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <ManagementSection
      title="Manage Events"
      description="Create and manage special events, wine tastings, tours, and seasonal celebrations at your venue."
      status="active"
    >
      <VenueEventsManagement venueId={id || ''} />
    </ManagementSection>
  );
};